import EmulatorSplashScreen from "../../components/EmulatorSplashScreen/EmulatorSplashScreen";
import React from "react";
import MobileSplashScreen from "../../components/MobileSplashScreen/MobileSplashScreen";
import {useQuery} from "../../utils/useQuery";
import EmulatorMainScreen from "../../components/EmulatorMainScreen/EmulatorMainScreen";
import {useSelector} from "react-redux";
import MobileMainScreen from "../../components/MobileMainScreen/MobileMainScreen";


const MobilePreview = (props) => {
    const { appId } = props.match.params;

    const query = useQuery();

    const screen = query.get('s')
    const height = query.get('height') || 1334

    const { splash } = json
    const { backgroundColor, contentColor, iconsColor, buttonColor, cardColor } = json.main

    if (screen === "main") {
        return (
            <MobileMainScreen
                backgroundColor={backgroundColor}
                contentColor={contentColor}
                iconsColor={iconsColor}
                buttonColor={buttonColor}
                cardColor={cardColor}
                viewportHeight={height}
            />
        )
    }

    return (
        <div>
            <MobileSplashScreen header={splash.header}
                                body={splash.body}
                                backgroundImage={splash.backgroundImage}
                                headerFont={splash.headerFont}
                                bodyFont={splash.bodyFont}
                                backgroundColor={splash.backgroundColor}
                                textColor={splash.textColor}
                                viewportHeight={height}
            />
        </div>
    )
}

export default MobilePreview;
